import React, { useState } from "react";
import { Loader2, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@/components/ui/dialog";

export const AddJobDialog = ({ open, onClose, onAdd }) => {
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [location, setLocation] = useState("");
  const [hasVideoBooth, setHasVideoBooth] = useState(false);
  const [adding, setAdding] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim() || !date) return;
    
    setAdding(true);
    try {
      await onAdd({ 
        title: title.trim(), 
        date, 
        location: location.trim(),
        has_video_booth: hasVideoBooth
      });
      setTitle("");
      setDate("");
      setLocation("");
      setHasVideoBooth(false);
      onClose();
    } finally {
      setAdding(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-[#605e5e]">
            Add New Job
          </DialogTitle>
          <DialogDescription className="text-sm text-[#8d8b8b]">
            Add a new job to the rota
          </DialogDescription>
        </DialogHeader>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="job-title">Event Name</Label>
            <Input
              id="job-title"
              placeholder="e.g., Lauren & Phil's Wedding Video & Photos"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              data-testid="job-title-input"
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="job-date">Date</Label>
            <Input
              id="job-date"
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              data-testid="job-date-input"
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="job-location">Venue</Label>
            <Input
              id="job-location"
              placeholder="Venue name"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              data-testid="job-location-input"
            />
          </div>
          
          <div className="flex items-center space-x-2">
            <Checkbox 
              id="video-booth"
              checked={hasVideoBooth}
              onCheckedChange={setHasVideoBooth}
              data-testid="job-video-booth-checkbox"
            />
            <Label htmlFor="video-booth" className="text-sm font-normal cursor-pointer">
              Video Booth Required
            </Label>
          </div>
          
          <DialogFooter className="pt-4">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button 
              type="submit" 
              disabled={adding || !title.trim() || !date}
              className="bg-[#605e5e] hover:bg-[#4b4a4a]"
              data-testid="add-job-submit-btn"
            >
              {adding ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
              Add Job
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
